import 'reflect-metadata';
import { jsonProperty } from 'ts-serializable';

import { AttachedFileModel } from '~modules/attachedFiles/models/AttachedFileModel';
import { UploadingStateEnum } from '~modules/attachedFiles/types/UploadingStateEnum';

export class UploadedFileModel extends AttachedFileModel {
  @jsonProperty(String) uploadingState: UploadingStateEnum = UploadingStateEnum.SUCCESS;
}
